<template>
  <div>
    <PageLoader :storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#427D2D" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #fff">{{ msg }}</span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #fff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-layout wrap justify-center>
      <v-flex xs12>
        <v-layout wrap justify-start pa-4>
          <v-layout row justify-space-between align-center>
            <v-flex xs12 sm8 md8 lg8>
              <span class="heading">State Medical Officers List</span>
            </v-flex>
            
            <v-flex xs12 sm4 md4 lg4 pt-2 pt-lg-0 pt-md-0 pt-sm-0 mt-2 class="text-right">
              <v-btn color="#427D2D" @click="openAddDialog()">
                <span style="font-size: 12px; font-family: poppinssemibold; color: white;">
                  Add State Medical Officer
                  <v-icon color="white">mdi-plus</v-icon>
                </span>
              </v-btn>
            </v-flex>
          </v-layout>

          <v-flex xs12 v-if="userlist && userlist.length > 0" pt-4>
            <v-layout wrap justify-start pt-2>
              <v-flex xs12>
                <v-card>
                  <div style="overflow-y: auto;">
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left tablehead">Name</th>
                            <th class="text-left tablehead">User Name</th>
                            <th class="text-left tablehead">Phone</th>
                            <th class="text-left tablehead">Email</th>
                            <th class="text-left tablehead">Scope</th>
                            <th class="text-left tablehead" v-if="mainRole === 'admin'">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in userlist" :key="index">
                            <td style="white-space: nowrap;" class="tableitems">{{ item.name }}</td>
                            <td style="white-space: nowrap;" class="tableitems">{{ item.username }}</td>
                            <td style="white-space: nowrap;" class="tableitems">{{ item.phone }}</td>
                            <td style="white-space: nowrap;" class="tableitems">{{ item.email || '-' }}</td>
                            <td style="white-space: nowrap;" class="tableitems">
                              <v-chip small color="green lighten-4" class="green--text text--darken-3 font-weight-medium">State Level</v-chip>
                            </td>
                            <td style="white-space: nowrap;" v-if="mainRole === 'admin'">
                              <v-icon small color="primary" class="mr-2" @click="openEditDialog(item)">mdi-pencil</v-icon>
                              <v-icon small color="error" class="mr-2" @click="rejectDialog(item._id)">mdi-delete</v-icon>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </div>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 v-else pt-4>
            <v-card class="text-center pa-6" flat outlined>
              <v-icon size="48" color="grey lighten-1">mdi-account-off-outline</v-icon>
              <div class="subheading text-grey mt-2">No State Medical Officers found</div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <!-- Add Dialog -->
    <v-dialog v-model="adddialog" max-width="600px">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          <span style="font-size: 18px; font-family: poppinssemibold; color: black;">
            ADD STATE MEDICAL OFFICER
          </span>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-layout wrap justify-start pt-2>
              <v-flex xs12 sm12 md6 lg6 pr-2 class="subheading">
                <span style="color:black">User Name</span>
                <v-text-field class="pt-2 text-des" outlined v-model="username" dense hide-details></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md6 lg6 class="subheading">
                <span style="color:black">Name</span>
                <v-text-field class="pt-2 text-des" outlined v-model="name" dense hide-details></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md6 lg6 pt-2 pr-2 class="subheading">
                <span style="color:black">Phone</span>
                <v-text-field class="pt-2 text-des" outlined v-model="phone" dense hide-details></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md6 lg6 pt-2 class="subheading">
                <span style="color:black">Email</span>
                <v-text-field class="pt-2 text-des" outlined v-model="email" dense hide-details></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 pt-2 class="subheading">
                <span style="color:black">Password</span>
                <v-text-field
                  :type="showPassword ? 'text' : 'password'"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  v-on:click:append="showPassword = !showPassword"
                  class="pt-2 text-des"
                  outlined
                  v-model="password"
                  dense
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 pt-2 class="subheading">
                <span style="color:black">Confirm Password</span>
                <v-text-field
                  :type="showCPassword ? 'text' : 'password'"
                  :append-icon="showCPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  v-on:click:append="showCPassword = !showCPassword"
                  class="pt-2 text-des"
                  outlined
                  v-model="cpassword"
                  dense
                  hide-details
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions class="py-4 justify-end headline lighten-2">
          <v-btn tile outlined color="#FF1313" light :ripple="false" depressed text @click="adddialog = false">
            <span style="color: black;">Cancel</span>
          </v-btn>
          <v-btn tile :color="appColor" light :ripple="false" depressed @click="itemadd()">
            <span style="color:white;">Save Changes</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Edit Dialog -->
    <v-dialog v-model="editDialog" max-width="600px">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          <span style="font-size: 18px; font-family: poppinssemibold; color: black;">
            EDIT STATE MEDICAL OFFICER
          </span>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-layout wrap justify-start pt-2>
              <v-flex xs12 sm12 md6 lg6 pr-2 class="subheading">
                <span style="color:black">User Name</span>
                <v-text-field class="pt-2 text-des" outlined v-model="editUsername" disabled dense hide-details></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md6 lg6 class="subheading">
                <span style="color:black">Name</span>
                <v-text-field class="pt-2 text-des" outlined v-model="editName" dense hide-details></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md6 lg6 pt-2 pr-2 class="subheading">
                <span style="color:black">Phone</span>
                <v-text-field class="pt-2 text-des" outlined v-model="editPhone" dense hide-details></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md6 lg6 pt-2 class="subheading">
                <span style="color:black">Email</span>
                <v-text-field class="pt-2 text-des" outlined v-model="editEmail" dense hide-details></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 pt-2 class="subheading">
                <span style="color:black">New Password (leave blank to keep current)</span>
                <v-text-field
                  :type="showEditPassword ? 'text' : 'password'"
                  :append-icon="showEditPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  v-on:click:append="showEditPassword = !showEditPassword"
                  class="pt-2 text-des"
                  outlined
                  v-model="editPassword"
                  placeholder="Enter new password"
                  dense
                  hide-details
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions class="py-4 justify-end headline lighten-2">
          <v-btn tile outlined color="#FF1313" light :ripple="false" depressed text @click="editDialog = false">
            <span style="color: black;">Cancel</span>
          </v-btn>
          <v-btn tile :color="appColor" light :ripple="false" depressed @click="updateOfficer()">
            <span style="color:white;">Update Officer</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Delete Dialog -->
    <v-dialog v-model="deleteDialog" max-width="500">
      <v-card>
        <v-card-title class="heading">Delete State Medical Officer</v-card-title>
        <v-card-text>Are you sure you want to delete this officer?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn tile outlined color="#FF1313" light :ripple="false" depressed @click="deleteDialog = false">Cancel</v-btn>
          <v-btn tile :color="appColor" light :ripple="false" depressed @click="deleteUser()">
            <span style="color: #fff">Confirm</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "StateMedicalOfficersList",
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      name: "",
      username: "",
      password: "",
      cpassword: "",
      phone: "",
      email: "",
      showPassword: false,
      showCPassword: false,
      adddialog: false,
      
      // Edit dialog state
      editDialog: false,
      editId: null,
      editUsername: "",
      editName: "",
      editPhone: "",
      editEmail: "",
      editPassword: "",
      showEditPassword: false,

      userlist: [],
      deleteDialog: false,
      deleteid: null,
      appColor: "#427D2D",
    };
  },
  mounted() {
    this.getData();
  },
  computed: {
    mainRole() {
      return this.$store.state.userRole;
    },
  },
  methods: {
    openAddDialog() {
      this.username = null;
      this.name = null;
      this.phone = null;
      this.email = null;
      this.password = null;
      this.cpassword = null;
      this.showPassword = false;
      this.showCPassword = false;
      this.adddialog = true;
    },
    openEditDialog(item) {
      this.editId = item._id;
      this.editUsername = item.username;
      this.editName = item.name;
      this.editPhone = item.phone;
      this.editEmail = item.email || "";
      this.editPassword = "";
      this.showEditPassword = false;
      this.editDialog = true;
    },
    rejectDialog(id) {
      this.deleteid = id;
      this.deleteDialog = true;
    },
    updateOfficer() {
      const phoneRegex = /^[0-9]{10}$/;
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!this.editName) {
        this.msg = "Please Provide Name.";
        this.showSnackBar = true;
        return;
      }
      if (!this.editPhone) {
        this.msg = "Please Provide Phone.";
        this.showSnackBar = true;
        return;
      }
      if (!phoneRegex.test(this.editPhone)) {
        this.msg = "Please Provide a Valid Phone Number (10 digits).";
        this.showSnackBar = true;
        return;
      }
      if (this.editEmail && !emailRegex.test(this.editEmail)) {
        this.msg = "Please Provide a Valid Email.";
        this.showSnackBar = true;
        return;
      }

      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/statemedicalofficer/edit",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.editId,
          name: this.editName,
          phone: this.editPhone,
          email: this.editEmail,
          password: this.editPassword,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.showSnackBar = true;
            this.editDialog = false;
            this.msg = response.data.msg;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    deleteUser() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/districtofficer/delete",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: { id: this.deleteid },
      })
        .then((response) => {
          this.appLoading = false;
          this.deleteDialog = false;
          if (response.data.status) {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    itemadd() {
      const phoneRegex = /^[0-9]{10}$/;
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!this.username) {
        this.msg = "Please Provide UserName.";
        this.showSnackBar = true;
        return;
      }
      if (!this.name) {
        this.msg = "Please Provide Name.";
        this.showSnackBar = true;
        return;
      }
      if (!this.phone) {
        this.msg = "Please Provide Phone.";
        this.showSnackBar = true;
        return;
      }
      if (!phoneRegex.test(this.phone)) {
        this.msg = "Please Provide a Valid Phone Number (10 digits).";
        this.showSnackBar = true;
        return;
      }
      if (this.email && !emailRegex.test(this.email)) {
        this.msg = "Please Provide a Valid Email.";
        this.showSnackBar = true;
        return;
      }
      if (!this.password) {
        this.msg = "Please Provide Password.";
        this.showSnackBar = true;
        return;
      }
      if (!this.cpassword) {
        this.msg = "Please Confirm Password.";
        this.showSnackBar = true;
        return;
      }
      if (this.password !== this.cpassword) {
        this.msg = "Password and Confirm Password must match.";
        this.showSnackBar = true;
        return;
      }

      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/statemedicalofficer/register",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          username: this.username,
          name: this.name,
          password: this.password,
          cpassword: this.cpassword,
          phone: this.phone,
          email: this.email,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.showSnackBar = true;
            this.adddialog = false;
            this.msg = response.data.msg;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/statemedicalofficer/list",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.userlist = response.data.data;
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.heading {
  font-size: 20px;
  font-family: poppinssemibold;
  color: #1b4d0e;
}
.tablehead {
  font-family: poppinssemibold;
  font-size: 13px;
  color: #1b4d0e !important;
}
.tableitems {
  font-family: poppinsregular;
  font-size: 13px;
}
</style>
